module.exports = __webpack_public_path__ + "img/tss22.9d509508.png";